<!-- 智能名片 -->
<template>
  <div class="cards">
    <div class="head-title">智能名片</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            展示个人名片信息、电话、微信、邮箱、企业动态、产品内容、公司简介等信息。<a
              class="help-link"
              href="https://www.weijub.com/index/index/news_detail?id=140"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="sec">
      <el-row>
        <el-col
          :span="5"
          style="margin-bottom: 3rem"
          v-for="(o, index) in list"
          :key="o"
          :offset="index % 4 >= 1 ? 1 : 0"
        >
          <el-card :body-style="{ padding: '.0rem' }">
            <img :src="o.url2" class="image" />
            <div style="padding: 1.4rem">
              <span>{{ o.name }}</span>
              <div class="bottom clearfix">
                <time class="time">{{
                  o.status == 1 ? "当前正在使用" : ""
                }}</time>
                <el-button
                  type="text"
                  class="button"
                  @click="onComfirm(o)"
                  v-if="o.status == 1"
                  >&emsp;&emsp;</el-button
                >
                <el-button
                  type="text"
                  class="button"
                  @click="onComfirm(o)"
                  v-else
                  >使用</el-button
                >
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardSearch",
  components: {},

  data() {
    return {
      list: [],
      type: "",
    };
  },

  computed: {},

  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      const { data: res } = await this.axios({
        url: "/crm/UserCardContent/cardlist",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
        }),
      });
      this.list = res.data;
      // console.log(this.list);
      // this.list.forEach((item)=>{
      //   console.log(item.status);
      //   this.status=item.status
      // })
    },
    async onComfirm(item) {
      this.$confirm("此操作将更改所有员工的名片样式, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.checkBaseMap(item);
          this.getList(item);
        })
        .catch(() => {});
    },
    async checkBaseMap(item) {
      const { data: res } = await this.axios({
        url: "/crm/UserCardContent/checkBaseMap",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          type: item.type,
          name: item.name,
          url1: item.url1,
          url2: item.url2,
        }),
      });
      if (res.code == 1) {
        this.getList();
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
      this.type = item.type;
      console.log(this.type);
    },
  },
};
</script>
<style  scoped>
.time {
  font-size: 1.3rem;
  color: #999;
}

.bottom {
  margin-top: 1.3rem;
  line-height: 1.2rem;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
